/* eslint-disable max-lines */
/* eslint-disable max-lines-per-function */
import { Button, SheetClose, Textarea } from '@e2n/ui';
import { useRotationsplanById } from '@/domain/mitarbeiter/features/rotationsplan/hooks/useRotationsplanById/useRotationsplanById';
import { useTranslation } from 'react-i18next';
import { Navigate, useParams } from 'react-router-dom';
import { UPDATE_BEWERTUNG_FORM_ID } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/constants';
import { SheetHeader, SheetTitle } from '@e2n/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import { useForm } from '@/domain/mitarbeiter/features/rotationsplan/features/UpdateBewertung/useForm';
import { useRegisterSheetForm } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/components/SheetWrapper/useRegisterSheetForm';
import { FieldBase } from '@/components/form';
import { ArbeitsbereichStationInfo } from '@/domain/mitarbeiter/features/rotationsplan/features/CreateBewertung/components/ArbeitsbereichStationInfo';
import { ArbeitsbereichStation } from '@/domain/mitarbeiter/features/rotationsplan/entities/Station';
import { Rating } from '@/components/FeadbackToggle/Rating';
import { DeleteBewertung } from '@/domain/mitarbeiter/features/rotationsplan/features/DeleteBewertung/DeleteBewertung';

export function UpdateBewertung() {
  const { t } = useTranslation();
  const { id, stationId, bewertungId } = useParams();
  const { rotationsplan } = useRotationsplanById(id);

  if (!rotationsplan || !stationId || !bewertungId) {
    return <Navigate to="/mitarbeiter/rotationsplaene" />;
  }

  const station = rotationsplan.allStationen
    .filter((station) => station instanceof ArbeitsbereichStation)
    .find((station) => station.id === stationId);

  if (!station || !station.bewertung) {
    return <Navigate to={`/mitarbeiter/rotationsplan/${rotationsplan.id}`} />;
  }

  const ratings = [
    {
      value: 1,
    },
    {
      value: 2,
    },
    {
      value: 3,
    },
    {
      value: 4,
    },
    {
      value: 5,
    },
  ];

  const form = useForm({
    bewertung: station.bewertung,
    rotationsplanId: id,
    stationId,
  });

  useRegisterSheetForm(form);

  return (
    <>
      <SheetHeader className="space-y-0 flex flex-row items-center justify-between bg-neutrals-200 px-4 py-2">
        <div className="flex items-center gap-2">
          <SheetClose>
            <Button
              variant="ghost"
              size="icon"
              aria-label={t('actions.back')}
              className="cursor-pointer">
              <FontAwesomeIcon icon={faArrowLeft} />
            </Button>
          </SheetClose>
          <SheetTitle className="text-sm text-neutrals-800">
            {t(
              'domain.mitarbeiter.rotationsplan.rotationsplaene.updateBewertung.title',
            )}
          </SheetTitle>
        </div>
        <div className="flex gap-3 items-center md:hidden">
          <DeleteBewertung bewertung={station.bewertung} />
          <Button form={UPDATE_BEWERTUNG_FORM_ID} variant="ghost-primary">
            {t('actions.fertig')}
          </Button>
        </div>
      </SheetHeader>
      <div className="flex flex-col gap-4 px-6 grow overflow-auto">
        <ArbeitsbereichStationInfo station={station} />
        <form
          id={UPDATE_BEWERTUNG_FORM_ID}
          className="flex flex-col gap-4 h-full"
          onSubmit={(e) => {
            e.preventDefault();
            form.handleSubmit();
          }}>
          <form.AppField name="sterne">
            {(field) => {
              const isInvalid =
                field.state.meta.isTouched && !field.state.meta.isValid;

              return (
                <FieldBase
                  data-invalid={isInvalid}
                  className="flex flex-col gap-1 w-full"
                  label={t(
                    'domain.mitarbeiter.rotationsplan.rotationsplaene.createBewertung.fields.sterne.label',
                  )}>
                  <Rating
                    ratings={ratings}
                    defaultValue={field.state.value}
                    onChange={(e) => field.handleChange(e)}
                  />
                </FieldBase>
              );
            }}
          </form.AppField>
          <form.AppField name="beurteilung">
            {(field) => {
              const isInvalid =
                field.state.meta.isTouched && !field.state.meta.isValid;

              return (
                <FieldBase
                  data-invalid={isInvalid}
                  className="flex flex-col gap-1 w-full"
                  label={t(
                    'domain.mitarbeiter.rotationsplan.rotationsplaene.createBewertung.fields.beurteilung.label',
                  )}>
                  <Textarea
                    defaultValue={field.state.value}
                    onChange={(e) => field.handleChange(e.target.value)}
                    maxLength={400}
                    showCounter
                  />
                </FieldBase>
              );
            }}
          </form.AppField>
        </form>
      </div>
      <div className="h-px w-full bg-neutrals-300" />
      <div className="hidden md:flex justify-end px-8 pb-4 gap-4">
        <DeleteBewertung bewertung={station.bewertung} />
        <Button
          type="submit"
          disabled={!form.state.isValid || form.state.isSubmitting}
          form={UPDATE_BEWERTUNG_FORM_ID}>
          {t('actions.fertig')}
        </Button>
      </div>
    </>
  );
}
